import { IDefineCommand } from 'core-ts-types';

angular
  .module('capability-ng-study-groups')
  .factory(
    'dismissStudyBuddyTileCommand',
    function dismissStudyBuddyTileCommandDefinition(
      $http: ng.IHttpService,
      defineCommand: IDefineCommand,
      log: any
    ): void {
      return defineCommand(
        'dismissStudyBuddyTileCommand',
        function dismissStudyBuddyTileCommand(deferred: ng.IDeferred<any>): any {
          $http
            .put(`study/last_joined_message`, {})
            .then(() => {
              deferred.resolve();
            })
            .catch(() => {
              log.error('Unable to dismiss study buddy tile');
              deferred.reject();
            });
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-study-groups/src/commands/dismiss_study_buddy_tile_command.ts